<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input lazy"
                @submit.prevent="storeGroup">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Add New Group</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col v-if="user.type==='admin'" class="py-0" cols="12" sm="6">
                            <company-select v-model="formData['company_id']" :items="companies" :rules="[vRules.required]"
                                      density="compact" label="Company">
                            </company-select>
                        </v-col>
                        <v-col class="py-0" cols="12" :sm="user.type==='admin' ? 6 : 12">
                            <v-text-field v-model="formData['name']"
                                          :rules="[vRules.required]" autofocus density="compact" label="Name"/>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="formData['description']"
                                        :rules="[vRules.required]" density="compact" label="Description"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import CompanySelect from "@/components/globals/company-select.vue";

const companies = ref([]);
const {user} = useAuthStore();
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
});
const formData = reactive({
    valid: false,
    name: null,
    description: null,
    company_id: ((user.type !== 'admin') ? user.company.id : null),
});
const emits = defineEmits(['update:modelValue', 'addGroup']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

onMounted(() => {
    if (user.type === 'admin') {
        fetchCompanies()
    }
})

const fetchCompanies = () => {
    send('get', `companies/list`)
        .then((response) => {
            companies.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            snackbar.showSnackbar('Companies could not be loaded', 'error')
        })
}
const storeGroup = () => {
    errors.value = [];
    send('post', `asset-groups`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('addGroup', {...response.data.data.asset_group, 'status': 'enabled'});
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
